<template>
  <Layout :class="{ 'overflow-back-off': servicesAndEnquiriesFlag }">
    <main class="main-wrap">
      <div class="min-s-hight">
        <section class="r-s-wrap">
          <div class="container devExtremeGridContainer">
            <div class="row">
              <div class="col-10 col-sm-8 col-md-8 col-lg-9">
                <h2 class="color-black mr-b30 pageHeading"
                  >Vendors List..
                  <img
                    src="/images/info.png"
                    alt=""
                    title="Management of vendors."
                /></h2>
              </div>
              <div
                class="col-2 col-xs-12 col-sm-4 col-md-4 col-lg-3 manageVendorScreen"
              >
                <!-- <button class="btn float-right">Add new</button> -->
                <button
                  type="button"
                  class="btn s-red-btn mr-b30 float-right"
                  @click="createVendor"
                >
                  <img
                    src="/images/add-circle.svg"
                    class="mr-r10 showimg"
                    alt=""
                    title=""
                  />Add New Vendor
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-check">
                  <input
                    id="exampleCheck1"
                    v-model="deactivateVendorFlag"
                    type="checkbox"
                    class="form-check-input"
                  />
                  <label class="form-check-label" for="exampleCheck1"
                    >Show all vendors
                  </label>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group has-search ">
                  <span class="fa fa-search form-control-feedback"></span>
                  <input
                    v-model="vendorNameSearched"
                    type="text"
                    class="form-control"
                    placeholder="Search"
                    @keyup.enter="vendorSearch(0)"
                  />
                </div> </div
            ></div>

            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <!-- <h2 class="color-black mb-4"
                  >Vendors <br />
                  (Temporary Data Rendered)
                  <img
                    src="/images/info.png"
                    alt=""
                    title=""
                  /></h2
                > -->

                <div class="services-tabs">
                  <div class="cus-tabs">
                    <DxDataGrid
                      ref="AllVendorArray"
                      :data-source="AllVendorArray"
                      :show-borders="true"
                      :hover-state-enabled="true"
                      :remote-operations="false"
                      :allow-column-reordering="true"
                      :row-alternation-enabled="false"
                      :column-hiding-enabled="true"
                      :show-column-lines="true"
                      :show-row-lines="true"
                      :column-auto-width="true"
                      key-expr="ProviderId"
                      @optionChanged="isLastPage"
                    >
                      <!-- <DxPaging :page-size="5" />
                      <DxPager
                        :show-page-size-selector="true"
                        :allowed-page-sizes="pageSizes"
                        :show-info="true"
                      /> -->

                      <!-- <DxFilterRow :visible="true" /> -->
                      <!-- <DxHeaderFilter :visible="true" /> -->
                      <DxGroupPanel :visible="true" />
                      <DxSearchPanel
                        :visible="false"
                        :highlight-case-sensitive="true"
                      />
                      <DxGrouping :auto-expand-all="true" />
                      <!-- <DxStateStoring
                        :enabled="true"
                        type="sessionStorage"
                        storage-key="storageVendor"
                      /> -->
                      <DxPager
                        :allowed-page-sizes="[5, 10, 20]"
                        :show-page-size-selector="true"
                        :show-info="true"
                        :show-navigation-buttons="true"
                      />
                      <DxPaging :page-size="20" />
                      <DxColumn
                        data-field="ProviderName"
                        caption="Vendor Name"
                        cell-template="CompanyNameTemplate"
                        :allow-sorting="true"
                      />
                      <div slot="CompanyNameTemplate" slot-scope="{ data }">
                        <h6> {{ data.ProviderName }} </h6>
                      </div>
                      <!-- commenting on 07-10-2022
                      <DxColumn
                        data-field="StripeAccountID"
                        caption="Vendor stripe payout account ID"
                        cell-template="StripeAccountIDTemplate"
                        :width="180"
                        :allow-sorting="true"
                      />
                      <div slot="StripeAccountIDTemplate" slot-scope="{ data }">
                        <h6> {{ data.StripeAccountID }} </h6>
                      </div> -->
                      <DxColumn
                        data-field="ProviderEmail"
                        caption="Service Count"
                        cell-template="emailTemplate"
                        :calculate-cell-value="filterOutServices"
                        :allow-sorting="true"
                        alignment="center"
                      />
                      <div
                        slot="emailTemplate"
                        slot-scope="{ data }"
                        class="center-align"
                        title="view"
                      >
                        <!-- <h6> Email Id </h6> -->
                        <h6
                          class="underline"
                          @click="redirectToPage(data.ProviderName, 1)"
                        >
                          {{ data.ServiceRequestForms.length }}
                        </h6>
                      </div>
                      <!-- <DxColumn
                        data-field="FirstName"
                        caption="Name"
                        cell-template="firstNameTemplate"
                        :width="200"
                      />
                      <div slot="firstNameTemplate" slot-scope="{ data }">
                        <h6 class="float-left">

                          {{ data.ProviderName }}
                        </h6>
                      </div> -->
                      <!-- <DxColumn
                        data-field="LastName"
                        caption="Last Name"
                        cell-template="lastNameTemplate"
                        :width="150"
                      />
                      <div slot="lastNameTemplate" slot-scope="{ data }">

                        <h6> {{ data.LastName ? data.LastName : '' }} </h6>
                      </div> -->

                      <DxColumn
                        data-field="ProviderPhone"
                        caption="Inquiries Count"
                        cell-template="phoneTemplate"
                        :calculate-cell-value="filterOutInquiries"
                        :allow-sorting="true"
                        alignment="center"
                      />
                      <div
                        slot="phoneTemplate"
                        slot-scope="{ data }"
                        class="center-align"
                        title="view"
                      >
                        <h6
                          class="underline"
                          @click="redirectToPage(data.ProviderName, 2)"
                          >{{ filterOutInquiries(data) }}
                        </h6>
                        <!-- <h6> 987654321</h6> -->
                      </div>

                      <!-- <DxColumn
                      data-field="BuildingName"
                      caption="Building Name"
                      cell-template="BuildingNameTemplate"
                    />
                    <div slot="BuildingNameTemplate" slot-scope="{ data }">
                      <h6> {{ data.BuildingName }} </h6>
                    </div> -->

                      <DxColumn
                        data-field="SandOStatus"
                        caption="Status"
                        cell-template="serviceStatus"
                        :calculate-cell-value="filterOutStatus"
                        alignment="left"
                        :allow-sorting="false"
                      />
                      <div
                        slot="serviceStatus"
                        slot-scope="{ data }"
                        title="view"
                      >
                        <h6 v-if="data.SandOStatus !== 1" class="float-left"
                          >Deactivate
                        </h6>
                        <h6 v-if="data.SandOStatus === 1" class="float-left"
                          >Active
                        </h6>
                      </div>

                      <DxColumn
                        data-field="Actions"
                        :allow-sorting="false"
                        :allow-grouping="false"
                        cell-template="actionTemplate"
                        :allow-header-filtering="false"
                      />
                      <div slot="imgTemplate" slot-scope="{ data }">
                        <img :src="data.iconurl" /><br />
                        <!-- <span class="ml-2">{{ data.CategoryName }}</span> -->
                      </div>
                      <div slot="actionTemplate" slot-scope="{ data }">
                        <div class="cursor-pointer ">
                          <a
                            class="cursor-pointer mr-3"
                            @click="vendorUserList(data)"
                          >
                            <span class="h6style hoverClass">View Users</span>
                          </a>
                          <a
                            class="cursor-pointer mr-3"
                            @click="editVendor(data)"
                          >
                            <span class="h6style hoverClass">Edit</span>
                          </a>

                          <a
                            v-if="data.SandOStatus === 1"
                            class="cursor-pointer mr-3"
                            @click="
                              approveRejectService_BLK(data.ProviderId, null)
                            "
                          >
                            <span
                              title="Deactivate vendor"
                              class="h6style hoverClass"
                              >Deactivate</span
                            >
                          </a>
                          <a
                            v-if="data.SandOStatus === null"
                            class="cursor-pointer mr-3"
                            @click="
                              approveRejectService_BLK(data.ProviderId, 1)
                            "
                          >
                            <span
                              title="Activate vendor"
                              class="h6style hoverClass"
                              >Activate </span
                            >&nbsp;&nbsp;
                          </a>

                          <a
                            class="cursor-pointer mr-3"
                            @click="deleteVendor(data)"
                          >
                            <span class="h6style hoverClass">Delete</span>
                          </a>
                        </div>
                      </div>

                      <DxSearchPanel
                        :visible="false"
                        :highlight-case-sensitive="true"
                      />
                    </DxDataGrid>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <loader v-if="loading"></loader>
        <popup
          v-if="showModal"
          :msg="postMessage"
          @response="closePopup"
        ></popup>
        <popup
          v-if="deleteVendorFlag"
          :msg="postMessage"
          @response="deleteVendorFlag = false"
        ></popup>
        <popup
          v-if="deleteWarnPop"
          :msg="postMessage"
          @response="deleteWarnPop = false"
        ></popup>

        <yesNoPopup
          v-if="showYNPopup"
          :msg="postMessage"
          @response="closeYNPopup"
        ></yesNoPopup>
        <servicesAndEnquiries
          v-if="servicesAndEnquiriesFlag"
          :vendor-id-for-deletion="vendorIdForDeletion"
          :msg="postMessage"
          @servicesAndEnquiriesClose="servicesAndEnquiriesClose"
        ></servicesAndEnquiries>
      </div>
    </main>
  </Layout>
</template>

<script>
import popup from '@views/popup'
import yesNoPopup from '@views/yesNoPopup'
import Layout from '@layouts/main'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.compact.css'
import '@/public/css/devExtremeGridCssModified.css'
import servicesAndEnquiries from './deleteServicesAndInquiries'
import {
  superAdminMethods,
  superAdminComputed,
  providerMethods,
  providerComputed,
} from '@state/helpers'
import loader from '@views/loader'
import appConfig from '@src/app.config'
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  // DxStateStoring,
  // DxHeaderFilter,
  // DxFilterRow,
} from 'devextreme-vue/data-grid'

export default {
  page: {
    title: 'Vendor List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout: Layout,
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
    DxSearchPanel,
    DxGrouping,
    DxGroupPanel,
    // DxStateStoring,
    // DxHeaderFilter,
    // DxFilterRow,
    loader,
    popup,
    yesNoPopup,
    servicesAndEnquiries,
  },

  data() {
    return {
      deactivateVendorFlag: false,
      superAdminServiceArray: [],
      serviceArrayForDeletion: [],
      inquiryArrayForDeletion: [],
      vendorIdForDeletion: null,
      AllVendorArray: [],
      loading: false,
      postMessage: null,
      showModal: false,
      deleteVendorFlag: false,
      servicesAndEnquiriesFlag: false,
      deleteWarnPop: false,
      vendorNameSearched: null,
      showYNPopup: false,
      vendorInformationForDeletion: {},
    }
  },

  computed: {
    ...superAdminComputed,
    ...providerComputed,
  },
  watch: {
    vendorNameSearched: {
      handler: function(val, oldVal) {
        console.log('val', val)
        if (!val) {
          this.AllVendorArray = []
          this.getServices_BL(0)
        }
      },
      deep: true,
    },
    deactivateVendorFlag: {
      handler: function(val, oldVal) {
        console.log('val', val)
        if (val) {
          localStorage.setItem('selectedFlagValue', 1)
        } else {
          localStorage.setItem('selectedFlagValue', 0)
        }
        if (this.vendorNameSearched && this.vendorNameSearched.length) {
          this.vendorSearch(0)
        } else {
          this.AllVendorArray = []
          console.log('AllVendorArray')
          this.getServices_BL(0)
        }
      },
      deep: true,
    },
  },

  created() {
    this.loading = true
    var selectedFlagValue = localStorage.getItem('selectedFlagValue')
    console.log('created -> selectedFlagValue', selectedFlagValue)
    if (parseInt(selectedFlagValue) === 1) {
      this.deactivateVendorFlag = true
    }
    this.getServices_BL(0)
  },

  methods: {
    ...superAdminMethods,
    ...providerMethods,
    // Filtering out of Inquires
    filterOutInquiries(data) {
      var inquiry = 0
      data.ServiceRequestForms.forEach((element) => {
        inquiry = inquiry + element['ServiceRequestFormEnquiries@odata.count']
      })
      return inquiry
    },
    // Count of Services
    filterOutServices(data) {
      return data.ServiceRequestForms.length
    },
    // Customization of the Column Name
    filterOutStatus(data) {
      if (data.SandOStatus === 1) return 'Activated'
      return 'Deactivated'
    },

    // Redirection to Services associated with Vendor
    redirectToPage(data, pageNo) {
      localStorage.setItem('search_vendor', data)
      if (pageNo === 1) {
        this.$router.push({
          name: 'vendor-service',
          query: {
            search_vendor: data,
          },
        })
      } else {
        this.$router.push({
          name: 'inquiry',
          query: {
            search_vendor: data,
          },
        })
      }
    },

    // Function to close the Modal
    servicesAndEnquiriesClose(flag) {
      this.servicesAndEnquiriesFlag = false
      // if (flag) this.getServices_BL(0)
      if (flag) {
        this.AllVendorArray = this.AllVendorArray.filter(
          (item) => item.ProviderId !== this.vendorIdForDeletion
        )
      }
    },
    // Function to delete the Vendor
    deleteVendor(vendorDetails) {
      console.log('vendorDetails', vendorDetails)
      this.vendorInformationForDeletion = vendorDetails
      if (this.vendorInformationForDeletion.ServiceRequestForms.length > 0) {
        this.vendorIdForDeletion = vendorDetails.ProviderId
        this.postMessage = 'Are you sure you want to delete vendor ?'
        this.servicesAndEnquiriesFlag = true

        // this.postMessage =
        //   'If you Delete this vendor, all services and inquiries associated with this vendor will be permanently deleted. However,if you still want to delete this vendor, you can click on Delete button.'

        // this.postMessage =
        //   'Please delete existing services by ' +
        //   '"' +
        //   this.vendorInformationForDeletion.ProviderName +
        //   '"'

        // this.deleteWarnPop = true
        // this.serviceArrayForDeletion = []
        // this.inquiryArrayForDeletion = []
        // this.vendorInformationForDeletion.ServiceRequestForms.forEach(
        //   (element1) => {
        //     this.serviceArrayForDeletion.push(element1.ServiceRequestFormId)
        //     element1.ServiceRequestFormEnquiries.forEach((element2) => {
        //       this.inquiryArrayForDeletion.push(element2.Id)
        //     })
        //   }
        // )
      } else {
        this.postMessage = 'Are you sure you want to delete vendor ?'
        this.showYNPopup = true
      }
    },

    // Function delete all Foreign Key Dependencies of Vendor
    closeYNPopup(val) {
      this.showYNPopup = false
      this.loading = false
      if (val === true) {
        this.loading = true

        this.deleteVendorMedia(this.vendorInformationForDeletion.ProviderMedias)
          .then((response1) => {
            console.log('closeYNPopup -> response1', response1)
            this.deleteVendorCategory(
              this.vendorInformationForDeletion.ProviderCategoryMappings
            )
              .then((response2) => {
                console.log('closeYNPopup -> response2', response2)
                this.deleteVendorFromDatabase(
                  this.vendorInformationForDeletion.ProviderId
                )
              })
              .catch(() => {
                this.loading = false
                this.postMessage = 'Something went wrong'
                this.showModal = true
              })
          })
          .catch(() => {
            this.postMessage = 'Something went wrong'
            this.loading = false
            this.showModal = true
          })
      }
    },
    // Function to delete all images associated with Vendor
    async deleteVendorMedia(imagesArray) {
      return new Promise((resolve, reject) => {
        if (imagesArray.length === 0) {
          resolve('success')
        } else {
          var i = 0
          console.log('deletionOfImages_BLK -> i', i)
          imagesArray.forEach(async (element) => {
            try {
              await this.deleteImagesFromProviderMedia_BLK({
                Id: element.Id,
              })
              i = i + 1
              if (i === imagesArray.length) {
                resolve('success')
              }
            } catch (error) {
              reject(error)
            }
          })
        }
      })
    },
    // Function to delete all Category associated with Vendor
    async deleteVendorCategory(categoryArray) {
      return new Promise((resolve, reject) => {
        if (categoryArray.length === 0) {
          resolve('success')
        } else {
          var i = 0
          console.log('deletionOfImages_BLK -> i', i)
          categoryArray.forEach(async (element) => {
            try {
              await this.deleteCategoryFromProviderCategoryMappings_BLK({
                Id: element.Id,
              })
              i = i + 1
              if (i === categoryArray.length) {
                resolve('success')
              }
            } catch (error) {
              reject(error)
            }
          })
        }
      })
    },
    // Function to delete vendor from database
    async deleteVendorFromDatabase(providerId) {
      console.log('deleteVendorFromDatabase -> providerId', providerId)
      try {
        this.loading = true
        var response = await this.deleteVendor_BLK({
          providerID: providerId,
        })
        console.log('deleteVendorFromDatabase -> response', response)

        this.loading = false
        if (
          response.status === '200' ||
          response.status === 200 ||
          response.status === '201' ||
          response.status === 201
        ) {
          this.postMessage = 'Vendor deleted successfully'
          this.AllVendorArray = this.AllVendorArray.filter(
            (item) => item.ProviderId !== providerId
          )
          this.deleteVendorFlag = true
        } else {
          this.postMessage = 'Something went wrong. Please try again'
          this.showModal = true
          this.loading = false
        }
      } catch (error) {
        this.loading = false
        this.postMessage = 'Something went wrong. Please try again'
        this.showModal = true
      }
    },

    // // Function to search vendor
    async vendorSearch(count, next = 0) {
      console.log('vendorSearch -> next', next)
      try {
        this.loading = true

        var temp = this.vendorNameSearched.trim().replace('&', '%26')
        var temp2 = temp.replace("'", "''")
        var response = await this.loadSearchedVendor_BLK({
          vendorName: temp2,
          recordAvailable: count,
          flagForDeactivateVendor: this.deactivateVendorFlag,
        })

        console.log('vendorSearch -> response', response)
        if (next) this.AllVendorArray = this.AllVendorArray.concat(response)
        else this.AllVendorArray = response
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log('vendorSearch -> error', error.message)
      }
    },
    // Pagination
    isLastPage(pagination) {
      // console.log('isLastPage -> pagination', pagination)
      var currentPage = pagination.value + 1
      var TotalPage = this.$refs['AllVendorArray'].instance.pageCount()
      // console.log('isLastPage -> currentPage', currentPage)
      var pageIndex = this.$refs['AllVendorArray'].instance.pageIndex() + 1
      if (
        pageIndex === currentPage &&
        currentPage === TotalPage &&
        this.AllVendorArray.length > 99
      ) {
        console.log('Pagination started working')
        if (this.vendorNameSearched && this.vendorNameSearched.length > 0)
          this.vendorSearch(this.AllVendorArray.length, 1)
        else this.getServices_BL(this.AllVendorArray.length, 1)
      } else if (pagination.fullName === 'paging.pageSize') {
        if (
          typeof pagination.previousValue === 'number' &&
          typeof pagination.value === 'number' &&
          pagination.value > pagination.previousValue &&
          this.AllVendorArray.length > 99
        ) {
          console.log('Pagination due to page size increment')
          if (this.vendorNameSearched && this.vendorNameSearched.length > 0)
            this.vendorSearch(this.AllVendorArray.length, 1)
          else this.getServices_BL(this.AllVendorArray.length, 1)
        }
      }
    },
    // Editing particular vendor
    editVendor(data) {
      localStorage.setItem('UserId', data.ProviderId)
      this.$router.push({
        name: 'edit-vendor',
        // params: { id: 0 },
      })
    },
    // Editing particular vendor
    vendorUserList(data) {
      console.clear()
      console.log(' data', data)
      localStorage.setItem('UserId', data.ProviderId)
      this.$router.push({
        name: 'vendor-user-list',
        query: {
          companyName: data.ProviderName,
        },
        // params: { id: 0 },
      })
    },
    // Creation of New Vendor
    createVendor() {
      console.log('create vendor ')
      localStorage.setItem('UserId', 0)
      this.$router.push({
        name: 'create-new-vendor',
        // params: { id: 0 },
      })
    },

    // Function to handle Archive operation
    async approveRejectService_BLK(vendor, status) {
      console.log('approveRejectService_BLK -> status', status)
      try {
        this.loading = true
        let vendorData = {
          SandOStatus: status,
        }
        const response = await this.activateDeactivateVendor_BLK({
          data: vendorData,
          id: parseInt(vendor),
        })
        this.loading = false
        if (
          response.status &&
          (response.status === 204 || response.status === '204')
        ) {
          this.postMessage = 'Vendor Status Updated Successfully'
          var objIndex = this.AllVendorArray.findIndex(
            (obj) => obj.ProviderId === vendor
          )
          this.AllVendorArray[objIndex].SandOStatus = status
          this.deleteVendorFlag = true
        } else {
          // this.postMessage = response.message
          this.postMessage = 'Something went wrong. Please try again'
          this.showModal = true
        }

        // this.getServices_BL(0)
        this.postCode = response.code

        // this.showModal = true
      } catch (error) {
        console.log('approveRejectService -> error', error)
        this.postMessage = 'Something went wrong. Please try again !'
        this.loading = false
        this.showModal = true
      }
    },

    // Function to get list of all vendors
    async getServices_BL(countValue, next = 0) {
      try {
        this.loading = true

        const responseBLK = await this.getListOfAllVendorForSandoAdmin_BLK({
          recordAvailable: countValue,
          flagForDeactivateVendor: this.deactivateVendorFlag,
        })
        this.loading = false
        console.log('superAdminServiceArray', this.AllVendorArray)
        if (next) this.AllVendorArray = this.AllVendorArray.concat(responseBLK)
        else this.AllVendorArray = responseBLK
      } catch (error) {
        console.log('Get services For Error ')
        this.loading = false
      }
    },

    // Close Modal Popup

    closePopup(val) {
      this.showModal = val
      // this.AllVendorArray = []
      // this.getServices_BL(0)
    },
  },
}
</script>

<style>
.showimg {
  display: none;
}

h6 {
  font-family: 'JosefinSans-SemiBold' !important;
  font-size: 14px;
}
.badgecss {
  font-size: 12px;
  padding-top: 5px;
}

.action-badge {
  color: white !important;
  text-decoration: none;
}

.h6style {
  font-family: 'JosefinSans-SemiBold' !important;
  font-size: 14px;
  border-bottom: 1px solid black;
}

.badgecss {
  font-size: 12px;
  padding-top: 9px;
  padding-bottom: 5px;
}
.has-search {
  width: 60%;
  margin-left: auto;
  position: relative;
  margin-bottom: 0px;
}
.has-search .form-control {
  padding-left: 2.375rem;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  /* height: 2.375rem; */
  height: calc(1.5em + 0.75rem + -4px);
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
  top: 0px;
  left: 10px;
}

@media (max-width: 576px) {
  .showimg {
    display: revert;
  }
  .manageVendorScreen .s-red-btn {
    font-size: 0;
    width: auto;
    width: 35px;
    padding: 0;
    min-width: auto;
    height: 38px;
    border-radius: 3px;
    min-width: 40px;
  }
  .s-red-btn img {
    margin: 0;
  }
  .pageHeading {
    font-size: 26px;
  }
  .has-search {
    width: 100%;
    /* border-top: 1px solid; */
    /* padding-top: 27px; */
    margin-bottom: 20px !important;
  }
  .form-check {
    margin-bottom: 20px !important;
  }
}
.form-check .form-check-input:checked ~ .form-check-label::before {
  background-color: black !important;
}
.underline {
  text-decoration-line: underline;
  font-size: 16px;
}
.underline:hover {
  color: #d13851;
}
</style>
